import React, { useState } from 'react';
import { Routering, searchForOrganisation } from './routering-service';
import Page from '../page/Page';
import { getTranslation } from '../locales/i18n';
import { ActionSpinner } from '../components/actionspinner/action-spinner';
import { RouteringCard } from './routering.card';
import { getDigidSysteemNaam } from './digidsysteem.model';

const RouteringPageView: React.FC<any> = () => {
  const [routeringen, setRouteringen] = useState<Routering[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [orgCode, setOrgCode] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const searchForOrg: any = () => searchForOrganisation(orgCode, setIsLoading, setRouteringen, setError);

  return (
    <Page title={getTranslation('routering.title.zoekresultaten')}>
      <div className="vl-input-field--inline vl-u-spacer">
        <input
          className="vl-input-field vl-input-field__input"
          type="text"
          id="identification"
          name="identification"
          data-cy="identification"
          placeholder={getTranslation('routering.identification')}
          onChange={(event) => setOrgCode(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              searchForOrg();
            }
          }}
        />
        <button className="vl-input-field__submit vl-button" onClick={searchForOrg}>
          <i className="vl-vi vl-vi-magnifier"></i>
        </button>
      </div>
      {isLoading && <ActionSpinner />}
      {!isLoading && error && <div className="error">{getTranslation('routering.fetching.error')}</div>}
      {routeringen && routeringen.length === 0 && (
        <div className="vl-col--1-1" data-cy={'no-data-text'}>
          {getTranslation('routering.noData.zoekresultaten')}
        </div>
      )}
      {routeringen &&
        routeringen.length > 0 &&
        routeringen.map((r) => {
          const digidNaam = getDigidSysteemNaam(r.digidSysteem);
          return (
            <RouteringCard digidNaam={digidNaam} {...r} key={r.uuid}>
              <div className="vl-info-tile__header__subtitle vl-u-spacer">{getTranslation('routering.section.' + r.status.toLowerCase(), { digidName: digidNaam })}</div>
            </RouteringCard>
          );
        })}
    </Page>
  );
};

export default RouteringPageView;
